var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class:
        "badge badge-" +
        _vm.$helpers.resolvePlaylistStatusBadge(_vm.status, _vm.type),
    },
    [_vm._v(_vm._s(_vm.status))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }